import React from "react";

export const ButtonSubmit = ({ disabled, text }) => {
  return (
    <button
      disabled={disabled}
      className={` h-12 px-5 mb-5 rounded-lg text-white text-lg font-semibold 
          ${disabled ? "bg-gray-400" : "bg-green-600"} `}
      type="submit"
    >
      {text}
    </button>
  );
};
